export const BaseEasingFunctions = {
  easeInQuint: (t) => t * t * t * t * t,
  easeOutQuint: (t) => 1 + --t * t * t * t * t,
  easeInOutQuint: (t) =>
    t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t,
  easeInCubic: (t) => t * t * t,
  easeOutCubic: (t) => --t * t * t + 1,
  easeInOutCubic: (t) =>
    t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
  easeInQuad: (t) => t * t,
  easeOutQuad: (t) => t * (2 - t),
  easeInOutQuad: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
  linear: (t) => t
};

/**
 * Creating a stepped easing function by rounding the values
 * of a smooth easing function. As the rounding happens on the
 * y value of the function it automatically makes sure that it
 * returns smaller x-steps for steep function slopes and bigger
 * x-steps for when the function eases in or out.
 *
 * For a visual explanation see:
 * https://graphtoy.com/?f1(x,t)=round(sin(x)%20*%202)%20/%202&v1=true&f2(x,t)=&v2=true&f3(x,t)=&v3=true&f4(x,t)=&v4=true&f5(x,t)=&v5=false&f6(x,t)=&v6=true&grid=1&coords=0,0,12
 */
export const makeSteppedEasing =
  (fn) =>
  (steps = 10) =>
  (t) => {
    const initialT = fn(t);
    return Math.round(initialT * steps) / steps;
  };

export const EasingFunctions = {
  stepIn: makeSteppedEasing(BaseEasingFunctions.easeInCubic),
  stepOut: makeSteppedEasing(BaseEasingFunctions.easeOutCubic),
  stepInOut: makeSteppedEasing(BaseEasingFunctions.easeInOutQuad),
  stepInOutCubic: makeSteppedEasing(BaseEasingFunctions.easeInOutCubic),
  stepOutCubic: makeSteppedEasing(BaseEasingFunctions.easeOutCubic),
  stepInOutQuint: makeSteppedEasing(BaseEasingFunctions.easeInOutQuint),
  stepOutQuint: makeSteppedEasing(BaseEasingFunctions.easeOutQuint),
  linear: makeSteppedEasing(BaseEasingFunctions.linear)
};
